// General
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, Validators, FormGroup, UntypedFormBuilder, FormArray, FormGroupDirective, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog'; // Importación actualizada
import { MessageBoxComponent } from 'src/app/modales/message-box/message-box.component';
// Error
import { ErrorStateMatcher } from '@angular/material/core';

/** Error when invalid control is dirty, touched, or submitted. **/
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

// Servicio
import { BibliotecaGeneralService } from 'src/app/services/biblioteca-general.service';
// Tabla
import { MatPaginator } from '@angular/material/paginator'; // Importación actualizada
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table'; // Importación actualizada

@Component({
    selector: 'app-gt-categorias',
    templateUrl: './gt-categorias.component.html',
    styleUrls: ['./gt-categorias.component.scss'],
    providers: [BibliotecaGeneralService],
    standalone: false
})
export class GtCategoriasComponent implements OnInit {

  /* Tabla */
  public length: number = 100;
  public pageSize: number = 100;
  public pageSizeOptions: Array<number> = [5, 10, 25, 100];
  public page: number = 1;
  public displayedColumns: string[] = [
    'id', 
    'nombre_de_categoria',
    'modificar',
    //'eliminar'
  ];
  public dataSource: MatTableDataSource<any>; // Cambiado a MatTableDataSource
  /* Fin tabla */
  public isLoading: boolean = false;
  public laravelapiStorage: any;
  public t: any;

  constructor(
    private fb: UntypedFormBuilder,
    public _dialog: MatDialog, // Cambiado aquí
    private _BibliotecaGeneralService: BibliotecaGeneralService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _cdRef: ChangeDetectorRef,
  ) { 
    this.getConsultarCategoriasBibliotecaPaginador(1);
    this.laravelapiStorage = this._BibliotecaGeneralService.getLaravelApiStorageTutores();
  }

  ngOnInit(): void {}

  public getConsultarCategoriasBibliotecaPaginador(page: number) {
    this.page = page;
    this.isLoading = true;
    this._BibliotecaGeneralService.getConsultarCategoriasBibliotecaPaginador(this.page, this.pageSize).subscribe(
      response => {
        console.log(response);
        this.isLoading = false;
        if (response.estado == 200) {
          this.length = response.data.length;
          this.dataSource = new MatTableDataSource(response.data.data); // Cambiado aquí
        }
      },
      error => {
        console.log(<any>error);
        this.isLoading = false;
      });
  }

  /* public postEliminarDocumentosOrg(id: number) {
    this.isLoading = true;
    this._BibliotecaGeneralService.postEliminarDocumentosOrg({ numero_documento: id }).subscribe(
      response => {
        console.log(response);
        this.isLoading = false;
        if (response.estado == 200) {
          this._dialog.open(MessageBoxComponent, { disableClose: true, data: { titulo: 'Operación Exitosa', mensaje: response.mensaje, icon: 'correct' } });
          this.getConsultarCategoriasBibliotecaPaginador();
        } else {
          this._dialog.open(MessageBoxComponent, { disableClose: true, data: { titulo: 'Error', mensaje: response.mensaje, icon: 'error' } });
        }
      },
      error => {
        console.log(<any>error);
        this._dialog.open(MessageBoxComponent, { disableClose: true, data: { titulo: 'Error', mensaje: 'Error con el Servicio.', icon: 'error' } });
        this.isLoading = false;
      });
  } */

  ngAfterContentChecked() {
    this.t = new Date().getTime();
    this._cdRef.detectChanges();    
  }

  public pageEvent(event: any) {
    console.info(event);
    this.pageSize = event.pageSize;
    this.getConsultarCategoriasBibliotecaPaginador(event.pageIndex + 1);
  }
}
